import React from 'react'

export default function ErrorPage() {
  return (
    <div className='center-content'>Odottamaton virhe sattui. Sulje selain ja yritä uudelleen...</div>
  )
}
